export { CategoriesVersion as Categories } from './CategoriesVersion';
